import { render, staticRenderFns } from "./DocLaunch.vue?vue&type=template&id=5ed2201d&scoped=true&"
import script from "./DocLaunch.vue?vue&type=script&lang=js&"
export * from "./DocLaunch.vue?vue&type=script&lang=js&"
import style0 from "./DocLaunch.vue?vue&type=style&index=0&id=5ed2201d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2201d",
  null
  
)

export default component.exports